/**
 * Centralizes authentication-provider classification so request interceptors can
 * avoid requesting Midway credentials for sessions authenticated elsewhere.
 */
import { fetchAuthSession } from 'aws-amplify/auth';

const AUTHN_PROVIDER_CLAIM = 'custom:authnProvider';

// This must stay byte-identical with PVMMELeelaService/src/middleware/
// user-context-middleware.ts AMAZON_EMAIL_DOMAINS.
export const AMAZON_EMAIL_DOMAINS = [
  '@amazon.com',
  '@amazon.co.uk',
  '@amazon.de',
  '@amazon.co.jp',
] as const;

// Captured 2026-08-25 via cognito-idp list-users on the beta pool after a fresh
// Midway sign-in; Federate Discovery Outcome claim auth_method_ref maps to
// custom:authnProvider. This must stay byte-identical with
// PVMMELeelaService/src/constants.ts INTERNAL_AUTHN_PROVIDERS.
export const INTERNAL_AUTHN_PROVIDERS = ['MIDWAY'] as const;

export async function isInternalUser (): Promise<boolean> {
  const session = await fetchAuthSession();
  const payload = session.tokens?.idToken?.payload;
  const authnProvider = payload?.[AUTHN_PROVIDER_CLAIM];

  if (authnProvider !== undefined) {
    return INTERNAL_AUTHN_PROVIDERS.some(
      (internalProvider) => internalProvider === authnProvider,
    );
  }

  // TODO: Remove this email-domain fallback once the prod Federate service
  // profile releases auth_method_ref and pre-claim sessions have refreshed.
  // Cleanup task: https://app.asana.com/1/8442528107068/project/1216839988408939/task/1217885782293561
  const email = payload?.email;
  return typeof email === 'string' && AMAZON_EMAIL_DOMAINS.some(
    (domain) => email.toLowerCase().endsWith(domain),
  );
}
